import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/dashboard';
import types from 'constants/actionTypes';

export const fetchDashboard = createThunk({
  apiCall: backendAPI.getDashboard,
  type: types.GET_DASHBOARD_REQUEST,
});
